"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isServiceType = exports.ServiceType = void 0;
var service_type_1 = require("./service-type");
Object.defineProperty(exports, "ServiceType", { enumerable: true, get: function () { return service_type_1.ServiceType; } });
Object.defineProperty(exports, "isServiceType", { enumerable: true, get: function () { return service_type_1.isServiceType; } });
